import { Card } from '@/components/shadcn-ui/card';
import { Input } from '@/components/shadcn-ui/input';
import { useDebounce } from '@/hooks/useDebounce';
import daysSinceHarvest from '@/lib/day-util';
import { getLots } from '@/network/api.service';
import { useLotStore } from '@/stores/useLot.store';
import { ChevronRight, Search } from 'lucide-react';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PreProcessPage = () => {
  const [query, setQuery] = React.useState('');

  const setLots = useLotStore(state => state.setLots);
  const lots = useLotStore(state => state.lots);

  const fetchLots = async q => {
    const params = {
      stage: 'PreProcess',
      ...(q ? { search: q } : {}),
    };
    const { data } = await getLots(params);
    setLots(data?.data);
  };

  const debouncedFetchLots = useDebounce(fetchLots, 300);

  useEffect(() => {
    debouncedFetchLots(query);
  }, [query, debouncedFetchLots]);

  return (
    <div className="flex flex-1 flex-col space-y-[18px] px-4 py-[18px]">
      <div className="rounded-2xl border border-[#E1E1E1] bg-white px-4 py-3 shadow-sm">
        <p className="text-base font-medium">Pre-processing lots</p>
      </div>

      {/* Search */}
      <div className="relative h-11">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search lots..."
          className="h-full rounded-[8px] bg-white pl-9 text-sm"
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
      </div>

      {/* List */}
      <div className="flex flex-col gap-3">
        {lots?.map(lot => (
          <Link
            key={lot._id}
            to={`/pre-process/${lot._id}`}
            className="text-left"
            onClick={() => {
              // navigate or open details
              console.log('Open lot', lot.id);
            }}
          >
            <Card className="flex items-center justify-between rounded-2xl border border-zinc-200 bg-white px-4 py-3 pt-3 shadow-sm">
              <div className="space-y-0.5">
                <p className="mb-1 text-base font-medium uppercase">{lot.lotname}</p>
                <p className="text-sm font-normal text-muted-foreground">{lot.estate.name}</p>
                <p className="text-sm font-normal text-muted-foreground">
                  {daysSinceHarvest(lot.date_of_harvest)} days since harvest
                </p>
              </div>
              <ChevronRight className="h-4 w-4 text-muted-foreground" />
            </Card>
          </Link>
        ))}

        {lots?.length === 0 && <p className="py-4 text-center text-xs text-muted-foreground">No lots found.</p>}
      </div>
    </div>
  );
};

export default PreProcessPage;
